import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { RetrieveService } from '../api/services/retrieve.service';
import { PartialFull } from '../api/models/partial-full';
import { SearchParams } from './partialfull-list.component';

/**
 * Data source for the PartialFull view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class PartialFullListDataSource implements DataSource<PartialFull> {

  private partialFullSubject = new BehaviorSubject<PartialFull[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private partialFullCount = new BehaviorSubject(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.partialFullCount.asObservable();

  constructor(private retrieveService: RetrieveService) {
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<PartialFull[]> {
    return this.partialFullSubject.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.partialFullSubject.complete();
    this.loadingSubject.complete();
  }

  loadContents(params: SearchParams) {

    this.loadingSubject.next(true);

    /* Retrieve contents */
    this.retrieveService.getPartialFullList(params).pipe(
      catchError(() => {
        // console.error('getContentsList ERROR');
        return of([]);
      }),
      finalize(() => {
        // console.log('getContentsList OK');
        this.loadingSubject.next(false);
      })
    ).subscribe(pf => {
      // console.log(contents);
      this.partialFullSubject.next(pf);
    });

    /* Count contents */
    this.retrieveService.countPartialFull(params).pipe(
      catchError(() => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    ).subscribe(count => {
      this.partialFullCount.next(count as number);
    });
  }
}

